import {PUSH_NOTIFICATIONS_PROMPT_TYPES} from '@/consts/pushNotifications/pushNotificationsPromptTypes';
import appContent from '@/services/content/appContent.typed';
import {schedulePushPromptIfNeeded} from '@/services/pushNotification/pushNotificationPromptService';
import appRouterService from '@/services/route/appRouterService';
import type {AutoDeliveryOrder} from '@/types/icc/autoDeliveryDetails';

import AutoDeliveryDcxOrderLabel from './AutoDeliveryDcxOrderLabel';
import AutoDeliveryDcxWidgetHeaderButton from './AutoDeliveryDcxWidgetHeaderButton';

interface AutoDeliveryDcxWidgetHeaderProps {
    onClick?: () => void;
    showManageButton?: boolean;
    showPastOrdersButton?: boolean;
    orderId?: AutoDeliveryOrder['orderId'];
}

const AutoDeliveryDcxWidgetHeader = ({
    onClick,
    showManageButton = true,
    showPastOrdersButton,
    orderId,
}: AutoDeliveryDcxWidgetHeaderProps) => {
    const content = appContent.getAutoDeliveryContent()?.dashboardContent;
    const {title, manageButton, pastOrdersButton} = content || {};

    const handleManageButtonClick = () => {
        schedulePushPromptIfNeeded(PUSH_NOTIFICATIONS_PROMPT_TYPES.AUTODELIVERY_DASHBOARD_CLICK);

        if (onClick) {
            onClick();
            return;
        }
        appRouterService.forwardToAutoDeliveryPage();
    };

    return (
        <div className='flex items-center justify-between gap-2'>
            <div className='flex flex-col items-start'>
                <h2 className='mb-0 overflow-hidden text-ellipsis whitespace-nowrap text-24 leading-[32px] ml:text-32 ml:leading-[42px]'>
                    {title}
                </h2>
                {orderId && <AutoDeliveryDcxOrderLabel orderId={orderId} className='md:hidden' />}
            </div>

            {showManageButton && (
                <AutoDeliveryDcxWidgetHeaderButton button={manageButton} onClick={handleManageButtonClick} />
            )}
            {showPastOrdersButton && <AutoDeliveryDcxWidgetHeaderButton button={pastOrdersButton} />}
        </div>
    );
};

export default AutoDeliveryDcxWidgetHeader;
